import { Button, Collapse, ColumnTable, Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../../locales/translations';
import { useWarningsSummaryDetailsLoader } from '../../loaders/StudentWarningsSummaryDetailsLoader';

type AcademicWarningGroupEvaluation = {
  evaluation: string;
  date: string;
  grade: string;
};

type AcademicWarningGroupCourse = {
  course: string;
  evaluations: AcademicWarningGroupEvaluation[];
};

const AcademicWarningGroup = () => {
  const { result } = useWarningsSummaryDetailsLoader();
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_DETAILS);
  const items = useMemo(() => {
    if (!result?.success) {
      return [];
    }

    return (result.data?.groupData as AcademicWarningGroupCourse[]) ?? [];
  }, [result]);

  const columns = useMemo<ColumnTable<AcademicWarningGroupEvaluation>[]>(
    () => [
      {
        columnName: 'evaluation',
        tdClassName: 'text-center',
        thClassName: 'text-center',
        headerText: t(`group.academic.table.evaluation`),
      },
      {
        columnName: 'date',
        tdClassName: 'text-center',
        thClassName: 'text-center',
        headerText: t(`group.academic.table.date`),
        cellFormat: ({ value }) => {
          if (!value) return '';
          const date = new Date(value);
          return date.toLocaleDateString();
        },
      },
      {
        columnName: 'grade',
        tdClassName: 'text-center',
        thClassName: 'text-center',
        headerText: t(`group.academic.table.grade`),
      },
    ],
    [t],
  );

  return (
    <div className="w-100 d-flex flex-column mt-3" style={{ gap: 12 }}>
      <Row>
        <Col xs={12}>
          <div className="d-flex justify-content-end">
            <Button
              text={t(`group.academic.actions.downloadReport`)}
              size="md"
              type="submit"
              icon="download"
              outlined
            />
          </div>
        </Col>
      </Row>
      {items.map((item, index) => (
        <Collapse
          key={index.toString()}
          headerClassName="bg-light rounded"
          renderTitle={() => (
            <span className="text-primary fw-700 fs-18">{item.course}</span>
          )}
        >
          <div
            style={{
              position: 'relative',
              transform: 'translateX(-1rem)',
              width: 'calc(100% + 2rem)',
            }}
            className="mt-2"
          >
            <Table data={item.evaluations} columns={columns} />
          </div>
        </Collapse>
      ))}
    </div>
  );
};

export default AcademicWarningGroup;
